import script from "./PhoneMask.vue?vue&type=script&lang=js"
export * from "./PhoneMask.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__